module.exports = __webpack_public_path__ + "img/CRV21.280138de.jpg";